import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppState } from "src/app/core/app.state";
import { ImportProductsService } from "../services/imports.services";
import { Store } from "@ngrx/store";
import { CommonService } from "src/app/shared/common.service";
import { catchError, finalize, map, of, switchMap, tap } from "rxjs";
import * as importsActions from './imports.actions'
import { APIResponse } from "src/app/core/models/api-response";
import { AlertEnums } from "src/app/shared/enums/shared.enums";
import { IExecuteSeccess, IImport, IResponseMatching } from "../models/imports.models";
import { TranslateService } from "@ngx-translate/core";


@Injectable()
export class ImportProductsEffects {
  constructor(
    private actions$: Actions,
    public store: Store<AppState>,
    private importProductsService: ImportProductsService,
    private commonService: CommonService,
    private translateService: TranslateService
  ) {}

  GetImportsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(importsActions.GetImports),
      tap(() => {
        this.store.dispatch(importsActions.SetImportLoader({isLoading: true}));
      }),
      switchMap((action) =>
        this.importProductsService.listImports(action.page, action.filter, action.key).pipe(
          map((res: APIResponse<IImport>) => importsActions.GetImportsSuccess({ imports: res})),
            catchError(() =>
            of(
            importsActions.GetImportsError()
            )),
            finalize(() => {
              this.store.dispatch(importsActions.SetImportLoader({isLoading: false}));
            })
          )
      ),
    )
  );

  importProductsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(importsActions.ImportProducts),
      tap(() => {
        this.store.dispatch(importsActions.SetImportLoader({isLoading: true}));
      }),
      switchMap((action) =>
        this.importProductsService.importProducts(action.file).pipe(
          map((res: APIResponse<IResponseMatching>) => importsActions.ImportProductsSuccess({ responseMatching: res.object!, reimport: action.reimport})),
          catchError(() =>
            of(
            importsActions.ImportProductsError()
            )
          ),
          finalize(() => {
            this.store.dispatch(importsActions.SetImportLoader({isLoading: false}));
          })
        )
      ),
    )
  );


  detailsImportEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(importsActions.DetailsImport),
      tap(() => {
        this.store.dispatch(importsActions.SetImportLoader({isLoading: true}));
      }),
      switchMap((action) =>
        this.importProductsService.detailsImport(action.id).pipe(
          map((res: APIResponse<IExecuteSeccess>) => importsActions.DetailsImportSuccess({ deatailsImport: res.object!})),
          catchError(() =>
            of(
            importsActions.DetailsImportError()
            )
          ),
          finalize(() => {
              this.store.dispatch(importsActions.SetImportLoader({isLoading: false}));
          })
        )
      ),
    )
  );

  ReImportProductsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(importsActions.ReImportProducts),
      tap(() => {
        this.store.dispatch(importsActions.SetImportLoader({isLoading: true}));
      }),
      switchMap((action) =>
        this.importProductsService.reImportProducts(action.id, action.file).pipe(
          map((res: APIResponse<IResponseMatching>) => importsActions.ReImportProductsSuccess({ responseMatching: res.object!})),
          catchError(() =>
            of(
            importsActions.ReImportProductsError()
            )
          ),
            finalize(() => {
              this.store.dispatch(importsActions.SetImportLoader({isLoading: false}));
            })
        )
      )
    )
  );

  matchingColumnsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(importsActions.MatchingColumns),
      tap(() => {
        this.store.dispatch(importsActions.SetImportLoader({isLoading: true}));
      }),
      switchMap((action) =>
        this.importProductsService.matchingColumns(action.id, action.matchingColumns).pipe(
            map((res: APIResponse<IExecuteSeccess>) => 
              importsActions.MatchingColumnsSuccess({ executeSeccess: res.object!, test: action.matchingColumns.test })
            ),
            tap((res) => {
              if(action.committed){
                this.commonService.showToast(
                  this.translateService.instant(`alerts.${AlertEnums.importAddSuccess}`),
                  'SUCCESS'
                );
              }
            }),
            catchError((error) => {
              return of(importsActions.MatchingColumnsError({ responseMatching: error.error.error }));
            }),
            finalize(() => {
              this.store.dispatch(importsActions.SetImportLoader({ isLoading: false }));
            })
          )
      )
    )
  );


}
